import { api } from '../createApi';
import { TagType } from '../TagType';

api.enhanceEndpoints({
  addTagTypes: [
    TagType.EsignatureIntegrations as TagType,
    TagType.TicketRecipients as TagType,
    TagType.EsignatureEnvelope as TagType,
    TagType.EsignatureTokenStatus as TagType,
    TagType.EsignatureActivities as TagType,
  ],
  endpoints: {
    // Tickets
    getEnvelope: {
      providesTags: (_result, _error, arg) => [
        {
          type: TagType.EsignatureEnvelope,
          id: arg.ticketId,
        },
      ],
    },
    getRecipients: {
      providesTags: (_result, _error, arg) => [
        {
          type: TagType.TicketRecipients,
          id: arg.ticketId,
        },
      ],
    },
    assignSigner: {
      invalidatesTags: (_result, _error, arg) => [
        {
          type: TagType.TicketRecipients,
          id: arg.ticketId,
        },
      ],
    },
    sendReminder: {
      invalidatesTags: (_result, _error, arg) => [
        {
          type: TagType.TicketRecipients,
          id: arg.ticketId,
        },
      ],
    },
    getTokenStatus: {
      providesTags: () => [
        {
          type: TagType.EsignatureTokenStatus,
          id: 'LIST',
        },
      ],
    },
    getEsignatureActivities: {
      providesTags: (_result, _error, arg) => [
        {
          type: TagType.EsignatureActivities,
          id: arg.ticketId,
        },
      ],
    },
    // Integrations
    createEsignatureIntegration: {
      invalidatesTags: [
        {
          type: TagType.EsignatureIntegrations,
          id: 'LIST',
        },
        {
          type: TagType.EsignatureTokenStatus,
          id: 'LIST',
        },
      ],
    },
    updateEsignatureIntegration: {
      invalidatesTags: (_result, _error, arg) => [
        {
          type: TagType.EsignatureIntegrations,
          id: arg.integrationId,
        },
        {
          type: TagType.EsignatureIntegrations,
          id: 'LIST',
        },
        {
          type: TagType.EsignatureTokenStatus,
          id: 'LIST',
        },
      ],
    },
    deleteEsignatureIntegration: {
      invalidatesTags: (_result, _error, arg) => [
        {
          type: TagType.EsignatureIntegrations,
          id: arg.integrationId,
        },
        {
          type: TagType.EsignatureIntegrations,
          id: 'LIST',
        },
        {
          type: TagType.EsignatureTokenStatus,
          id: 'LIST',
        },
      ],
    },
    getEsignatureIntegrations: {
      providesTags: (result: any) => [
        {
          type: TagType.EsignatureIntegrations,
          id: 'LIST',
        },
        ...(result?.map((integration: any) => ({
          type: TagType.EsignatureIntegrations,
          id: integration.id,
        })) ?? []),
      ],
    },
    revokeIntegrationUsers: {
      onQueryStarted: async (
        { integrationId, token_ids },
        { dispatch, queryFulfilled },
      ) => {
        const patchResult = dispatch(
          api.util.updateQueryData(
            'getEsignatureIntegrations',
            undefined,
            (draft) => {
              const integration = draft.find((i) => i.id === integrationId);
              if (integration) {
                integration.attributes.authenticated_user_count = Math.max(
                  integration.attributes.authenticated_user_count -
                    token_ids.length,
                  0,
                );
              }
            },
          ),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    },
  },
});
